import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1033 4.90635C15.5709 4.73232 15.8856 4.29111 15.8856 3.79365V1.36963C15.8856 0.708691 15.3512 0.174316 14.6903 0.174316H1.32385C0.662915 0.174316 0.12854 0.708691 0.12854 1.36963V3.82002C0.12854 4.31748 0.441431 4.75693 0.907251 4.93271C1.75452 5.25264 2.35745 6.07178 2.35745 7.03154C2.35745 7.99131 1.75452 8.81045 0.907251 9.13037C0.441431 9.30615 0.12854 9.74561 0.12854 10.2431V12.5493C0.12854 13.2103 0.662915 13.7446 1.32385 13.7446H14.6885C15.3494 13.7446 15.8838 13.2103 15.8838 12.5493V10.2255C15.8838 9.72627 15.5692 9.28682 15.1016 9.11279C14.249 8.79287 13.6426 7.97197 13.6426 7.00869C13.6426 6.04541 14.249 5.22451 15.1033 4.90635ZM11.3574 8.6874C11.3574 9.00029 11.1043 9.25342 10.7914 9.25342H5.18577C4.87288 9.25342 4.61975 9.00029 4.61975 8.6874C4.61975 8.37451 4.87288 8.12139 5.18577 8.12139H10.7914C11.1026 8.12139 11.3574 8.37451 11.3574 8.6874ZM11.3627 5.3124C11.3627 5.62529 11.1096 5.87842 10.7967 5.87842H5.1928C4.87991 5.87842 4.62678 5.62529 4.62678 5.3124C4.62678 4.99951 4.87991 4.74639 5.1928 4.74639H10.7985C11.1096 4.74639 11.3627 4.99951 11.3627 5.3124Z"
      fill="#9CA6A9"
    />
  </svg>
);

export default SVGComponent;
